<template>
  <div v-if="bodyShow" class="progress-main">
    <div class="content" v-html="page.content"></div>
    <a class="recruing_a" v-if="data.level==2" @click="$router.push({
                    path:'/training_money',
                    query:{
                        course_id:$route.query.course_id,
                        type: 100
                    }
                })">发展下级</a>
    <div v-else>
      <a class="recruing_a recruing_as" v-if="data.status==0">系统审核中</a>
      <a class="recruing_a" v-else @click="apply_show=true">申请成为{{data.role}}</a>
    </div>
    <van-popup v-model="apply_show" position="bottom" class="apply_pop">
      <img src="@a/app_close.png" alt="" @click="apply_show=false" />
      <div class="clearfix"></div>
      <van-cell-group class="groupings">
        <van-field placeholder="请填写你的手机号码" v-model="mobile" />
      </van-cell-group>
      <h3>*手机格式不正确，无法提交哦</h3>
      <a @click="applt_click" v-if="mobile!=''">提交</a>
      <a class="no_on" v-else>提交</a>
    </van-popup>
    <van-popup v-model="assistant_show" class="pop_assistant">
      <div class="pop_assistant_box">
        <img :src="page.qrcode_url" alt="公众号二维码" />
        <h3>关注公众号，不错过审核结果！</h3>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  recruit,
  apply
} from "@/api/training";
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        bodyShow: false,
        data: {},
        page: {},
        mobile: '',
        apply_show: false,
        assistant_show: false
      }
    },
    methods: {
      applt_click() {
        if (!(/^1[3456789]\d{9}$/.test(this.mobile))) {
          this.$toast('您输入的手机号不正确！');
          return;
        }
        apply({
            course_id: this.$route.query.course_id,
            phone: this.mobile
          })
          .then((data) => {
            if (data.code === 10002) {
              this.$toast(data.msg);
              return
            }
            this.$toast('提交成功！');
            this.apply_show = false;
            this.pullData();
          });
      },
      pullData() {
        recruit({
            course_id: this.$route.query.course_id
          })
          .then((data) => {
            if (data.code === 10002) {
              this.$toast(data.msg);
              return
            }

            this.bodyShow = true;
            this.data = data;
            this.page = data.page;
            if(!data.subscribe && data.status===0){
              this.assistant_show = true;
            }
            shareCon("training", this);
          });
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
  .content {
  padding: 60px;
}

.recruing_a {
  position: fixed;
  bottom: 0;
  width: 100%;
  line-height: 98px;
  background: rgba(235, 80, 50, 1);
  font-size: 34px;
  color: #fff;
  text-align: center;
}

.recruing_as {
  background-color: #EBAC32;
}

.apply_pop {
  background: #fff;
  img {
    float: right;
    width: 24px;
    margin: 30px;
  }
  .groupings {
    border: none;
    width: 578px;
    margin: 0 auto;
    margin-top: 20px;
    .van-cell {
      background-color: transparent;
      padding: 10px 0;
      border-bottom: 2px solid #ccc;
      .van-cell__value input {
        border: none;
        font-size: 32px;
        color: #333;
        line-height: 40px;
      }
    }
  }
  h3 {
    font-size: 24px;
    color: #EB5032;
    width: 578px;
    margin: 0 auto;
    margin-top: 10px;
    line-height: 24px;
  }
  a {
    width: 100%;
    line-height: 98px;
    background: rgba(235, 80, 50, 1);
    font-size: 34px;
    color: #fff;
    text-align: center;
    display: block;
    margin-top: 40px;
  }
  .no_on {
    background-color: #ccc;
  }
}

.van-hairline--top-bottom::after {
  border-width: 0
}

.pop_assistant {
  text-align: center;
  background-color: transparent;
  .pop_assistant_box {
    width: 600px;
    border-radius: 8px;
    background-color: #fff;
    padding: 105px 60px 84px;
    img {
      width: 434px;
      height: 434px;
    }
    h3 {
      margin-top: 44px;
      font-size: 32px;
      color: #333333;
      line-height: 50px;
      span.on {
        color: #EB5032;
      }
    }
    h4 {
      margin-top: 16px;
      font-size: 24px;
      color: #666;
      line-height: 20px;
    }
  }
}
</style>
